import { apiDelete, apiGet, apiPost } from 'api/service';

export function listOastSessions(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/api/oast/sessions/${query ? `?${query}` : ''}`);
}

export function createOastSession(body = {}) {
  return apiPost('/api/oast/sessions/', body);
}

export function rotateOastSession(id) {
  return apiPost(`/api/oast/sessions/${id}/rotate/`, {});
}

export function clearOastSessionEvents(id) {
  return apiPost(`/api/oast/sessions/${id}/clear_events/`, {});
}

export function listOastSessionEvents(id) {
  return apiGet(`/api/oast/sessions/${id}/events/`);
}

export function deleteOastSession(id) {
  return apiDelete(`/api/oast/sessions/${id}/`);
}
